// ----------------------------------------------------------------------------
// Component: Hero Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';
import 'snippets/video-player/video-block';

// Styles
import './_hero-banner.scss';

// Scripts for Videos
function heroBannerVideo() {
    const heroBannerVideos = document.querySelectorAll('#hero-banner__video');

    for (const heroBannerVideo of heroBannerVideos) {
        var mobileSrc = heroBannerVideo.dataset.mobileSrc;
        var desktopSrc = heroBannerVideo.dataset.src;

        // switching the video source for mobile vs desktop screens
        if (window.innerWidth < 680) {
            if (mobileSrc) {
                var source = document.createElement('source');
                source.type="video/mp4";
                source.src = mobileSrc;

                while (heroBannerVideo.firstChild) {
                    heroBannerVideo.removeChild(heroBannerVideo.firstChild);
                }
                heroBannerVideo.appendChild(source);
                heroBannerVideo.load();
            }
        } else {
            if (desktopSrc) {
                var source = document.createElement('source');
                source.type="video/mp4";
                source.src = desktopSrc;

                while (heroBannerVideo.firstChild) {
                    heroBannerVideo.removeChild(heroBannerVideo.firstChild);
                }
                heroBannerVideo.appendChild(source);
                heroBannerVideo.load();
            }
        }
    }

}

heroBannerVideo();

var cachedWidth = window.innerWidth;
window.addEventListener("resize", function() {
    var newWidth = window.innerWidth;

    // prevent resize function to trigger on mobile when scrolling
    if(newWidth !== cachedWidth){
        //DO RESIZE HERE
        cachedWidth = newWidth;

        // trigger the function only when resize is finished
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(heroBannerVideo, 100);
    }
});